import { localStore } from './storage'
import { setLoading } from './helper'
import { getLocation } from 'bs-sdk'
export interface LocInfo {
  cityId: string
  cityName: string
  lat: string
  lng: string
  adcode: string
  [prod: string]: any
}

export type Location = LocInfo | null
/**
 *
 * @param hasLoading 是否有loading默认有
 */
export async function getPosition(hasLoading = true, cache = 30): Promise<Location> {
  let position: Location | null = null
  if (hasLoading) setLoading()
  try {
    position = await getLocation(cache)
  } catch (error) {
    console.log(error)
  } finally {
    if (hasLoading) setLoading(false)
  }
  console.log('获取定位', position)
  return position
}
